import $ from 'jquery';

global.$ = $;
global.jQuery = $;
global.jquery = $;

import { Collapse } from 'bootstrap';
import 'leaflet';
import 'leaflet-providers';
require('leaflet.markercluster');

import LazyLoadManager from "../../services/lazyLoadManager";
import scrollAffixManager from "../../services/scrollAffixManager.js";
import groupCardManager from "../../services/book/groupCardManager";
import showChollosManager from "../../services/group/showChollosManager.js";
import activityReviewManager from "../../services/activityReview/activityReviewManager"
import HotelReviewManager from "../../services/hotelReview/hotelReviewManager";
import SearcherManager from "../../services/search/searcherManager";
import ChollosFilterer from "../../services/filterer/chollos/chollosFilterer";
import FreeCancelPoliciesListener from "../../services/listener/freeCancelPoliciesListener";
import MyAppConfig from "../../myApp.config";
import BrowserStorageService from "../../services/browserStorageService";
import UserManager from "../../services/userManager";
import DeviceDetector from "../../services/deviceDetector";
import UrlManager from "../../services/urlManager";
import ScrollManager from "../../services/scrollManager";
import DomAnimator from "../../services/domAnimator";
import TextTransformer from "../../services/dom/utilities/textTransformer"
import CollapseManager from "../../services/dom/utilities/collapseManager";
import DateFormatter from "../../services/dateFormatter";
import DomManager from "../../services/dom/domManager";
import TranslatorService from "../../services/translator/translatorService";
import AffixManager from "../../services/affixManager";
import FormObserver from "../../services/forms/formObserver";
import FormPrinter from "../../services/forms/formPrinter";
import FormValidator from "../../services/forms/formValidator";
import FormGroupValidator from "../../services/forms/formGroupValidator";
import FormSubmitterManager from "../../services/forms/formSubmitter";
import NewsletterSubscriptionValidator from "../../services/forms/validator/newsletterSubscriptionValidator";
import DropdownManager from "../../services/dom/utilities/dropdownManager";
import SubscribeManager from "../../services/subscribeManager";
import BrowserHistoryManager from "@web/vpt-assets/assets/js/utilities/dom/browserHistoryManager";
import CustomModalManager from "@web/vpt-assets/assets/js/utilities/customModalManager";
import CustomDropdownManager from "@web/vpt-assets/assets/js/utilities/dropdownManager";
import EmailCleaner from "../../services/forms/emailCleaner";
import Lightbox from "../../services/lightbox/lightbox";
import MenuManager from "../../services/menu/menuManager";
import SearchSuggest from "../../services/search/searchSuggest";
import CopyTextManager from "../../util/copyTextManager";
import CholloManager from "../../services/entity/cholloManager";
import InfoGroupManager from "../../services/book/infoGroupManager";
import HotelCustomMapBuilder from "../../services/customMap/hotelCustomMapBuilder";
import ReviewsManager from "../../services/reviewsManager";
import ServicesController from "@web/vpt-assets/assets/js/controller/servicesController";
import CollapseManagerNew from "@web/vpt-assets/assets/js/utilities/collapseManager";
import UserLoginRegisterModalHandler
    from "@web/vpt-assets/assets/js/modules/userLoginRegister/userLoginRegisterModalHandler";
import InfoActiveAccountHandler from "@web/vpt-assets/assets/js/modules/userLoginRegister/infoActiveAccountHandler";
import ItineraryManager from "../../services/itinerary/itineraryManager";
import TrackersManager from "../../services/trackers/trackersManager";
import GroupThematicReviewManager from "../../services/group/groupThematicReviewManager";
import UserWebFavouriteGroupManager from "../../services/user/userWebFavouriteGroupManager";
import SearchManager from "../../services/search/searchManager";
import SliderManager from "../../services/slider/sliderManager";
import SliderManagerWebComponents from "@web/web-components/js/components/sliderManager"
import * as Swiper from "swiper";
import InteractionCookieSetter from "@web/vpt-assets/assets/js/utilities/interaction/interactionCookieSetter";
import * as Sentry from "@sentry/browser";
import ModalManager from "@web/web-components/js/components/modalManager";
import CustomSlider from "@web/web-components/custom-slider/src/customSlider";
import GalleryManager from "@web/vpt-assets/assets/js/modules/gallery/galleryManager";
import SuggestedChollosSliderManager from "../../services/suggestedChollosSliderManager";
import SendBudget from "../../services/book/sendBudget";

global.myApp = {
    initializer: {},
    form: {
        book: {},
        validator: {},
        dataTransformer: {}
    },
    controller: {
        subscribeController: {},
        step1Controller: {},
        step2Controller: {},
        step3Controller: {}
    },
    translator: {},
    mapBuilder: {},
    book: {},
    user: {},
    menu: {},
    filterer: {},
    components: {
        time: {}
    },
    tracking: {
        gtm: {},
        ga: {}
    },
    lightboxList: [],
    config: []
};

$(function () {
    myApp.myAppConfig = new MyAppConfig();
    myApp.config.rootPath = myApp.myAppConfig.rootPath;
    myApp.config.cdnPath = myApp.myAppConfig.cdnPath;
    myApp.config.analytics = myApp.myAppConfig.analytics;
    myApp.browserStorageService = new BrowserStorageService();
    myApp.userManager = new UserManager();
    myApp.deviceDetector = new DeviceDetector();
    myApp.urlManager = new UrlManager();
    myApp.scrollManager = new ScrollManager();
    myApp.domAnimator = new DomAnimator();
    myApp.textTransformer = new TextTransformer();
    myApp.collapseManager = new CollapseManager();
    myApp.reviewsManager = new ReviewsManager();
    myApp.dateFormatter = new DateFormatter();
    myApp.domManager = new DomManager();
    myApp.translatorService = new TranslatorService();
    myApp.affixManager = new AffixManager();
    myApp.infoGroupManager = new InfoGroupManager();
    myApp.form.observer = new FormObserver();
    myApp.form.formPrinter = new FormPrinter();
    myApp.formValidator = new FormValidator();
    myApp.formGroupValidator = new FormGroupValidator();
    myApp.formSubmitterManager = new FormSubmitterManager();
    myApp.form.validator.newsletterSubscriptionValidator = new NewsletterSubscriptionValidator();
    myApp.dropdownManager = new DropdownManager();
    myApp.subscribeManager = new SubscribeManager();
    const servicesController = new ServicesController();
    myApp.browserHistoryManager = servicesController.getService(BrowserHistoryManager.className);
    myApp.form.dataTransformer.EmailCleaner = new EmailCleaner();
    new UserLoginRegisterModalHandler();
    myApp.customModalManager = servicesController.getService(CustomModalManager.className, {'closeImmediately': myApp.config.parameters.isIOSApp});
    myApp.user.userWebFavouriteGroupManager = new UserWebFavouriteGroupManager();
    new SearchManager();

    myApp.cholloManager = new CholloManager();
    new InfoActiveAccountHandler({
        isUserLoggedIn: myApp.config.isUserLoggedIn,
        isActivateAccount: activateAccountInfo['userActivate']
    });

    myApp.lightbox = new Lightbox();
    myApp.menu.manager = new MenuManager();
    const modalManager = new ModalManager();
    const customSlider = new CustomSlider();
    new GalleryManager(modalManager, customSlider, SliderManagerWebComponents, Swiper, myApp.deviceDetector.isXsScreen());

    const hotelSelector = document.querySelector('[data-filter="chollos"][data-type="hotels"]');
    if (typeof idHotelGrupo !== 'undefined' && hotelSelector) {
        hotelSelector.querySelector('[value="' + idHotelGroup + '"]').setAttribute("selected", "selected");
        const hotels = document.querySelectorAll('#groupSubchollos article');
        hotels.forEach((hotel) => {
            if (hotel.getAttribute('data-hotelId') !== idHotelGroup) {
                hotel.style.display = 'none';
            } else {
                hotel.style.display = '';
            }
        });
    }

    myApp.chollosFilterer = new ChollosFilterer();
    new CollapseManagerNew();

    new scrollAffixManager();
    new groupCardManager();
    new SendBudget();
    new ItineraryManager();
    new showChollosManager();
    myApp.groupThematicReviewManager = new GroupThematicReviewManager();
    new HotelReviewManager();
    new activityReviewManager();
    new SearcherManager();
    new FreeCancelPoliciesListener();
    new SearchSuggest();
    new CopyTextManager();
    new TrackersManager();
    new InteractionCookieSetter(Sentry.captureException.bind(Sentry));
    const sliderManager = new SliderManager();
    sliderManager.addSlider('[data-entity="reviews-with-photos"] [data-entity="slider"]', null, null);
    new SuggestedChollosSliderManager();
    $(document).ready(function () {
        myApp.hotelCustomMapBuilder = new HotelCustomMapBuilder();
    });
    myApp.customDropdownManagerNew = new CustomDropdownManager();

    let url_string = window.location.href;
    let modalToOpen = url_string.substring(url_string.indexOf('#')+ 1);
    let idHotelOrGrupo = "";
    const numericValue = /\d+/;
    let modalClick = "";

    if (modalToOpen.match(numericValue)) {
        idHotelOrGrupo = modalToOpen.match(numericValue)[0];
    } else {
        idHotelOrGrupo = 0;
    }

    if (modalToOpen.includes('mapa-hotel')) {
        modalClick = 'data-id=' + idHotelOrGrupo;
        $('[data-action="showMapModal"][' + modalClick + ']').click();
    } else if (modalToOpen.includes('fotos')) {
        modalClick = 'data-gallery-id=' + idHotelOrGrupo;
        $('[' + modalClick + ']').click();
    } else if (modalToOpen.includes('ver-precios')) {
        modalClick = 'data-scrollto-container=".group-subchollos"';
        $('[' + modalClick + ']').click();
    }
});
